{
    "ekg": {
        "qtc": {
            "score": 6
        }
    },
    "age": {
        "years": {
            "score": 3
        }
    },
    "gender": {
        "bio": {
            "score": 3
        }
    },
    "gewicht": {
        "bmi": {
            "score": 1
        }
    },
    "heartdisease": {
        "hypertension": {
            "score": 3
        },
        "cardiomyopathy": {
            "score": 3
        },
        "ejectionfraction": {
            "score": 3
        },
        "arrhythmia": {
            "score": 3
        }
    },
    "metabolic": {
        "diabetes": {
            "score": 0.5
        },
        "thyroid": {
            "score": 3
        }
    },
    "neurologic": {
        "general": {
            "score": 0.5
        }
    },
    "liver": {
        "stage": {
            "score": 1
        }
    },
    "elektrolyt": {
        "kalium": {
            "score": 6
        },
        "calcium": {
            "score": 3
        }
    },
    "entzündung": {
        "crp": {
            "score": 1
        }
    },
    "renal": {
        "gfr": {
            "score": 0.5
        }
    }
}